import { Page } from '../../../components/Page/Page';
import { SettingsSubjectsTable } from '../../../components/Subjects/Tables/SettingsSubjectsTable';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const SettingsSubjectsSubpage = () => {
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageSettings()}>
      <SettingsSubjectsTable />
    </Page>
  );
};
